import { langTypes } from 'config/langType';

export default function getNavigatorLangForAdmin() {
    const lang = navigator.language.toLowerCase();
    if (lang === 'zh-tw') return langTypes.ZH_TW;
    if (lang === 'ja' || lang.startsWith('ja-')) return langTypes.JA_JP;
    return langTypes.EN_US;
}
